import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  desc,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
        <i className={`${icon} text-3xl`} />
      </div>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {desc && <p className="mt-2 max-w-md text-sm text-foreground-600">{desc}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}